(function($)
{
    $.fn.ItemsPanelSlider = function()
    {
        return $(this).each(function()
        {
            let $element = $(this);
            let options = $element.data("itemspanelslider");

            if( options instanceof ItemsPanelSlider )
            {
                options.flush();
            }
            else
            {
                if( typeof options !== "object" )
                {
                    options = {};
                }
                let Ips = new ItemsPanelSlider($element[0], options);
                $element.removeAttr("itemspanelslider").data("itemspanelslider", Ips);
            }
        });
    };

})(jQuery);

let ItemsPanelSlider = function(block, options)
{
    if( options.hasOwnProperty("direction") && ["v", "h"].indexOf(options.direction) < 0 )
    {
        throw new Error("Invalid option direction value '"+ options.direction +"'")
    }

    // options
    this.options = Object.assign({
        "direction": "h", // ou "v"
        "slide_speed": 800 // ms
    }, options);

    // dom elements
    this.$block = $(block);
    this.$elementID = this.$block.attr("id");
    this.$previous_case = this.$block.find((
        this.options.direction === "h"
            ? "ul > li:first-child"
            : "ul:first-child > li:first-child"
    ));
    this.$next_case = this.$block.find((
        this.options.direction === "h"
            ? "ul > li:nth-child(3)"
            : "ul:nth-child(3) > li:first-child"
    ));
    this.$view = this.$block.find((
        this.options.direction === "h"
            ? "ul > li:nth-child(2) > div"
            : "ul:nth-child(2) > li > div"
    ));
    this.$view_mover = this.$view.children("div");

    // unitialized properties
    this.resizeTimeout = null;

    this.viewOffset =
    this.countItems =
    this.currentPanel =
    this.panelItemsCount =
    this.countPanels = null;

    // binds
    let Ips = this;

    this.$view.on("touchmove", function(ScrollEvent)
    {
       ScrollEvent.preventDefault();
    });

    $(window).on("resize", function()
    {
        clearTimeout(Ips.resizeTimeout);
        Ips.resizeTimeout = setTimeout(function()
        {
            Ips.goToPanel(1);
            Ips.init();
        }, 100);
    });

    this.$previous_case.on("click", function()
    {
        if( !Ips.$previous_case.data("in-use") )
        {
            Ips.$previous_case.data("in-use", true);
            Ips.previous();
        }
    });

    this.$next_case.on("click", function()
    {
        if( !Ips.$next_case.data("in-use") )
        {
            Ips.$next_case.data("in-use", true);
            Ips.next();
        }
    });

    let nextEventNameListen = (this.options.direction === "h" ? "z:swipeleft" : "z:swipeup" ),
        previousEventNameListen = (this.options.direction === "h" ? "z:swiperight" : "z:swipedown" );

    this.$view.on(previousEventNameListen, function()
    {
        Ips.$previous_case.trigger("click");
    });

    this.$view.on(nextEventNameListen, function()
    {
        Ips.$next_case.trigger("click");
    });

    // store maths and sizes
    this.init();

    // init views
    this.updateView();
    this.updateControlsAvailability();
};

ItemsPanelSlider.prototype = {
    "init": function()
    {
        this.viewOffset = ( this.options.direction === "h" ? this.$view[0].getBoundingClientRect().width : this.$view[0].getBoundingClientRect().height );
        this.countItems = this.$view_mover.children().length;
        this.currentPanel = 1;
        let firstItem = this.$view_mover.children().first();
        let itemSize = ( this.options.direction === "h" ? firstItem[0].getBoundingClientRect().width : firstItem[0].getBoundingClientRect().height );
        this.panelItemsCount = Math.floor(this.viewOffset / itemSize );
        this.countPanels = Math.ceil(this.countItems / this.panelItemsCount);
    },
    "updateControlsAvailability": function()
    {
        if( this.currentPanel === 1 )
        {
            this.$previous_case.css("opacity", 0.1);
            this.$previous_case.removeClass("cursor-pointer");
        }
        else
        {
            this.$previous_case.css("opacity", 1);
            this.$previous_case.addClass("cursor-pointer");
        }

        if( this.currentPanel === this.countPanels )
        {
            this.$next_case.css("opacity", 0.1);
            this.$next_case.removeClass("cursor-pointer");
        }
        else
        {
            this.$next_case.css("opacity", 1);
            this.$next_case.addClass("cursor-pointer");
        }
    },
    "updateView": function()
    {
        let newOffset = (this.viewOffset * -(this.currentPanel-1));
        let Ips = this;

        // instant
        /*let moveProperty = {"h": "margin-left", "v": "margin-top"}[Ips.options.direction];
        this.$view_mover.css(moveProperty, newOffset +"px");
        this.$previous_case.data("in-use", false);
        this.$next_case.data("in-use", false);*/

        // used unofficial lib to smooth the move
        let moveProperty = {"h": "x", "v": "y"}[Ips.options.direction];
        let transitionProps = {};
        transitionProps[moveProperty] = newOffset;
        this.$view_mover.transition(transitionProps, 800, function()
        {
            Ips.updateControlsAvailability();
            Ips.$next_case.data("in-use", false);
            Ips.$previous_case.data("in-use", false);
        });

        // jquery solution
        /*let moveProperty = {"h": "left", "v": "top"}[Ips.options.direction];
        let transitionProps = {};
        transitionProps[moveProperty] = newOffset +"px";
        this.$view_mover.animate(transitionProps, 1000, function()
         {
             Ips.$next_case.data("in-use", false);
             Ips.$previous_case.data("in-use", false);
         });*/
    },
    "next": function()
    {
        if( this.currentPanel < this.countPanels )
        {
            this.goToPanel(this.currentPanel + 1)
        }
        else
        {
            this.$next_case.data("in-use", false);
        }
    },
    "previous": function()
    {
        if( this.currentPanel > 1 )
        {
            this.goToPanel(this.currentPanel - 1);
        }
        else
        {
            this.$previous_case.data("in-use", false);
        }
    },
    "goToPanel": function(panelNumber)
    {
        if( panelNumber >= 1 && panelNumber <= this.countPanels && panelNumber !== this.currentPanel )
        {
            this.currentPanel = panelNumber;
            this.updateView();
        }
    }
};
